/**
 * 386 (#1278): the gap kept between two customers' rentals of a car, in the PO's 30-minute steps (0–120). One list for
 * the Settings card and the car form, so the two can never offer different choices.
 */
export const BUFFER_CHOICES: Array<{ value: number; label: string }> = [
  { value: 0, label: 'None (rentals may touch)' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '1 hour' },
  { value: 90, label: '1 hour 30 minutes' },
  { value: 120, label: '2 hours' },
];

/** A gap as staff read it ("None" for 0). */
export function bufferLabel(minutes: number): string {
  if (minutes === 0) return 'None';
  return BUFFER_CHOICES.find((c) => c.value === minutes)?.label ?? `${minutes} minutes`;
}
